import { render } from "./TableEntries.vue?vue&type=template&id=63367bb4"
import script from "./TableEntries.vue?vue&type=script&lang=js"
export * from "./TableEntries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/GenericComponents/TableEntries.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63367bb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63367bb4', __exports__)) {
    api.reload('63367bb4', __exports__)
  }
  
  module.hot.accept("./TableEntries.vue?vue&type=template&id=63367bb4", () => {
    api.rerender('63367bb4', render)
  })

}


export default __exports__